module.exports = __webpack_public_path__ + "img/CriticalDia-Go-min.f8e72cf4.png";